// extracted by mini-css-extract-plugin
export default {"productCarousel":"B1-z"};